import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import type { VendorLicenseTask } from "@services/licensing/types";
import { canUserReject } from "../../flow/utils";

export interface LicenseFlowData {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
}

interface RejectLicenseProps {
  licenseFlowData?: LicenseFlowData;
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "licensing";

const RejectLicense: React.FC<RejectLicenseProps> = ({ licenseFlowData, openDrawer }) => {
  if (!licenseFlowData || !licenseFlowData.task) return null;

  const isActionAvailable = Boolean(
    canUserReject(
      licenseFlowData.task.status,
      licenseFlowData.task.claimOwnerName,
      licenseFlowData.status,
    ),
  );

  const handleRejectClick = () => {
    openDrawer("rejectDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission={["canApprovePortOperatorLicense", "canApproveVendorLicense"]}
      isActionAvailable={isActionAvailable}
      onReject={handleRejectClick}
    />
  );
};

export default RejectLicense;
